import { render, staticRenderFns } from "./books-large.vue?vue&type=template&id=a99a4d48&scoped=true&"
import script from "./books-large.vue?vue&type=script&lang=js&"
export * from "./books-large.vue?vue&type=script&lang=js&"
import style0 from "./books-large.vue?vue&type=style&index=0&id=a99a4d48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a99a4d48",
  null
  
)

export default component.exports